export default __webpack_public_path__ + "static/media/file.736fb54f.svg";